// Feature flag de bascule entre l'ancien comparateur voyage (Auctor, sur /guide/assurance-voyage)
// et le nouveau funnel (/devis-assurance-voyage).
//   '1'          → nouveau funnel actif (Auctor masqué, CTA vers le funnel)
//   absent/autre → ancien comparateur Auctor (défaut sûr pour le rollout, cf. loan/health)
export function isTravelFunnelEnabled(): boolean {
    return process.env.NEXT_PUBLIC_ENABLE_TRAVEL_COMPARATOR === '1'
}
